import TomSelect from 'tom-select';
import { MobileMenu } from './parts/mobile-menu.js';
import './parts/megamenu';
import './parts/search';
import './parts/blog-filter.js';
import './parts/project-filter.js';
import './parts/load-more.js';
import './parts/image-gallery.js';
import './parts/gravityforms.js';
import './parts/faqs.js';
import './parts/timeline-block.js';
import './parts/gallery-filter-block.js';

// mmenu light
window.addEventListener("DOMContentLoaded", () => {
    
    MobileMenu( "responsive-menu" );

    let selectIDs = [ 'product-for', 'looking-for' ]
    
    selectIDs.forEach( elementID => {
        let select = document.getElementById(elementID);
        if(select){
            new TomSelect(select, {
                create: false,
                controlInput: null
            });

        }
    } )

} );